import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { v4 } from "uuid"

export const ModalAnswerKey = ({ show, homework, close }) => {
  const { t } = useTranslation()
  const [answers, setAnswers] = useState({})
  useEffect(() => {
    if (!homework) return
    const ans = {}
    homework.homework_answers.forEach((answer) => {
      ans[answer.question_no] = answer.answer
    })
    console.log(ans)
    setAnswers(ans)
  }, [homework?.id])
  return (
    <Modal show={show} onHide={() => close()}>
      <Modal.Header>
        <div className="tw-font-bold tw-text-bold">
          {homework?.name} {t("answer_key")}
        </div>
      </Modal.Header>
      <Modal.Body>
        {homework &&
          Object.keys(homework?.answers_key).map((qno) => (
            <div
              key={v4()}
              className={`tw-border-b tw-border-b-gray-300  tw-text-white ${answers[qno] == homework?.answers_key[qno] ? "tw-bg-green-800" : "tw-bg-red-800"}`}>
              <div className="tw-flex tw-items-center tw-justify-between tw-text-lg tw-space-x-5 p-2">
                <div className="tw-space-x-5">
                  <span className="tw-font-bold">{qno})</span>
                  <span className="tw-font-bold">{homework?.answers_key[qno]}</span>
                </div>
                <div className="">
                  {answers[qno] == homework?.answers_key[qno] ? (
                    <i className="fa fa-check"></i>
                  ) : (
                    <i className="fa fa-times"></i>
                  )}
                </div>
              </div>
            </div>
          ))}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => close()}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  )
}
